import React from 'react'
import { API, graphqlOperation } from 'aws-amplify'

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { RootState, AppDispatch } from './managers/redux/store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

type ConfigType<VariableType extends {}> = {
    query: string;
    key: string;
    variables?: VariableType;
};